import React, { useState, useEffect, useCallback } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Table,
} from "reactstrap";
import "./index.css";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import FromNow from "components/Time/FromNow";
import api from "api";
import { UserInfo, UserCompanyListingResponse } from "model/user";
import { ApiResponse, SelectOption } from "model/response";
import {
  TransformationRunLog,
} from "model/transformation";
import TransformationRunLogItem from '../../components/TransformationRunLogItem';
import _ from "lodash";

const PAGE_LIMIT = 6;
interface ListingData {
  transformationRunLogs: Array<TransformationRunLog>;
  page: number;
  total: number;
}

export default function TransformationRunLogListing() {
  const companyId: any = api.getCurrentCompanyId();
  const match = useRouteMatch("/transformation/:transformation_id");
  const params: any = match?.params;
  const transformationId = params?.transformation_id;

  const [currentUser, setCurrentUser] = useState<UserInfo | null>(null);
  const [listingData, setListingData] = useState<ListingData>({
    transformationRunLogs: [],
    page: 0,
    total: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [listingData?.page]);

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    setLoading(false);
  };

  async function fetchData() {
    let url = `transformation/${transformationId}/run_log?limit=50`;
    // setLoading(true)
    const res: ApiResponse = await ApiCaller.get(url);
    if (res?.status === "ok") {
      const data: any = res?.data;
      console.log('data', data);
      setListingData({
        ...listingData,
        ...{ transformationRunLogs: data },
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  const getRowIcon = (run_log:TransformationRunLog) => {
    let iconToDisplay:string = 'stop_circle'
    if (run_log.status === 'success') {
      iconToDisplay = 'check_circle';
    }
    if (run_log.status === 'running') {
      iconToDisplay = 'play_circle_filled';
    }
    if (run_log.status === 'failed') {
      iconToDisplay = 'cancel';
    }
    return iconToDisplay;
  }

  if (loading) return <Loading />;

  return (
    <Container>
      <Table>
        <thead>
          <th>Status</th>
          <th>Run ID</th>
          <th>Message</th>
          <th>Duration</th>
          <th>End time</th>
        </thead>
        <tbody>
          {listingData?.transformationRunLogs?.map(runLog =>
            <TransformationRunLogItem
              key={runLog.id}
              transformationRunLog={runLog}
            />
          )}
        </tbody>
      </Table>
    </Container>
  );
}
